const Error = () => {
  return (
    <div>
      <h1>This is the error page</h1>
    </div>
  )
}

export default Error
